module.exports = __webpack_public_path__ + "teqbahn-assets/media/11.79edf1ad.png";